export { default } from './RecentlyReturnedPrintList';



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedPrintList/index.js